import { useSelector } from "react-redux"

export const useIsReferralEnabled = () => {
  const { userInfo } = useSelector((state) => state.auth)
  const { businessAccountsWithRole } = useSelector((state) => state.user)
  const hasOwnerBA = businessAccountsWithRole?.some((ba) => ba?.role?.id === 1)
  return !!userInfo?.is_referral_feature_enabled && hasOwnerBA
}
